import { useEffect, useState } from 'react'
import moment from 'moment'

export function useCurrentMoment() {
  const [val, setVal] = useState<moment.Moment>(moment())

  useEffect(() => {
    const interval = setInterval(() => {
      setVal(moment())
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  })

  return val
}
